<img
  class="close"
  *ngIf="closable"
  [src]="'icons/close.svg' | assetsPath | async"
  alt="close icon"
  (click)="close.emit()"
/>
<ng-content></ng-content>
